module.exports = "https://r.nearpod.com/assets/media/image/mp-well-done-8c758d5d9fdcac728d9efbf35e1a360f.svg";